import { ChangeAppActionTypes } from '../constants/actionType';
const { MnHOneClick } = ChangeAppActionTypes;

const initialState = {
    EnableSubmit: "",
    isPortedAccount:"",
    SkipPrefetch: "",
    AccountType: "vision",
    SourceType: "urc",
    FlowRoute: "",
    promoKeyWord: "",
    showPromoKeyWord: false,
    MFRT: "",
    FlowType: "accordion",
    Vcustid: "",
    Vactid: "0001",
    State: "",
    changeResponse: null,
    changeDescription: "",
    activeView: 'default',
    CRMMSARespStatus: "",
    CRMMBundleRespStatus: "",
    CRMMPromoRespStatus: "",
    CRMMProfileRespStatus: "",
    PegaRecommendationRespStatus: "",
    sspGridRespSaveCallStatus: "",
    PN: "",
    SmartcartEnable: false,
    EnableMixandMatch2: false,
    enableInHomeHSI:'',
    enableinhomeclassictp: '',
    enableinhomeclassicdp: '',
    enableinhomeclassicsa: '',
    qamless:'',
    FQGLoyalty:'',
    pegaMandM:'',
    mnhOneClick: {
        addressId: '',
        mtn: '',
        marketingProfileResp: '',
        marketingProfileRespSaveCallStatus: '',
        loopQualResp: '',
        loopQualRespSaveCallStatus: '',
        locusAddressValidationResp: '',
        locusAddressValidationRespSaveCallStatus: '',
        oneCreditResp: '',
        oneCreditRespSaveCallStatus: '',
        vzwAccountNumber: '',
        vzwAccountDetails: '',
        vzwAccountRadioBtn: 'N',
        qualSaveCallStatus: '',
        showMlpOptions: true,
        redirectQueryString: undefined,
        crmmStandaloneResp: '',
        crmmBundleResponse: '',
        crmmPromoResponse: '',
        crmmEquipmentResponse: '',
        crmmVasResponse: '',
        vzwOfferEligibilityResp: '',
        wirelessDataToken: '',
        wirelessDataTokenEncryptStatus: '',
        mhToken: '',
        visitProfilejson: ''
    },
    SkipPegaRecommendation: true,
    loadVHA:false
};

function changeApp(state = initialState, action) {
    switch (action.type) {
        case 'CHANGE_VALIDATEINPUT':
            return Object.assign({}, state, {
                EnableSubmit: action.value.rdEnableSubmit !== undefined &&
                    action.value.rdEnableSubmit !== state.EnableSubmit ? action.value.rdEnableSubmit : state.EnableSubmit,
                isPortedAccount: action.value.isPortedAccount !== undefined &&
                    action.value.isPortedAccount !== state.EnableSubmit ? action.value.isPortedAccount : state.isPortedAccount,
                SkipPrefetch: action.value.rdSkipPrefetch !== undefined &&
                    action.value.rdSkipPrefetch !== state.SkipPrefetch ? action.value.rdSkipPrefetch : state.SkipPrefetch,
                AccountType: action.value.AccountType !== undefined &&
                    action.value.AccountType !== state.AccountType ? action.value.AccountType : state.AccountType,
                SourceType: action.value.SourceType !== undefined &&
                    action.value.SourceType !== state.SourceType ? action.value.SourceType : state.SourceType,
                FlowRoute: action.value.FlowRoute !== undefined &&
                    action.value.FlowRoute !== state.FlowRoute ? action.value.FlowRoute : state.FlowRoute,
                MFRT: action.value.MFRT !== undefined &&
                    action.value.MFRT !== state.MFRT ? action.value.MFRT : state.MFRT,
                FlowType: action.value.FlowType !== undefined &&
                    action.value.FlowType !== state.FlowType ? action.value.FlowType : state.FlowType,
                Vcustid: action.value.txtVcustid !== undefined && action.value.txtVcustid !== state.Vcustid ? action.value.txtVcustid : state.Vcustid,
                Vactid: action.value.txtVactid !== undefined &&
                    action.value.txtVactid !== state.Vactid ? action.value.txtVactid : state.Vactid,
                State: action.value.txtState !== undefined &&
                    action.value.txtState !== state.State ? action.value.txtState : state.State,
                PN: action.value.txtToken !== undefined &&
                    action.value.txtToken !== state.Token ? action.value.txtToken : state.Token,
                SmartcartEnable: action.value.rdEnableSmartCart !==undefined &&
                    action.value.rdEnableSmartCart !== state.SmartcartEnable ?  action.value.rdEnableSmartCart : state.SmartcartEnable,  
                EnableMixandMatch2: action.value.rdEnableMM2 !==undefined &&
                    action.value.rdEnableMM2 !== state.EnableMixandMatch2 ?  action.value.rdEnableMM2 : state.EnableMixandMatch2,    
                    enableInHomeHSI: action.value.enableInHomeHSI !== undefined &&
                    action.value.enableInHomeHSI !== state.enableInHomeHSI ?  action.value.enableInHomeHSI : state.enableInHomeHSI,
                enableinhomeclassictp: action.value.enableinhomeclassictp !== undefined &&
                    action.value.enableinhomeclassictp !== state.enableinhomeclassictp ?  action.value.enableinhomeclassictp : state.enableinhomeclassictp,    
                enableinhomeclassicdp: action.value.enableinhomeclassicdp !== undefined &&
                    action.value.enableinhomeclassicdp !== state.enableinhomeclassicdp ?  action.value.enableinhomeclassicdp : state.enableinhomeclassicdp,    
                enableinhomeclassicsa: action.value.enableinhomeclassicsa !== undefined &&
                    action.value.enableinhomeclassicsa !== state.enableinhomeclassicsa ?  action.value.enableinhomeclassicsa : state.enableinhomeclassicsa,
                qamless:action.value.qamless !== undefined &&
                action.value.qamless !== state.qamless ?  action.value.qamless : state.qamless,
                FQGLoyalty:action.value.FQGLoyalty !== undefined &&
                action.value.FQGLoyalty !== state.FQGLoyalty ?  action.value.FQGLoyalty : state.FQGLoyalty ,
                pegaMandM:action.value.pegaMandM !== undefined &&
                action.value.pegaMandM !== state.pegaMandM ?  action.value.pegaMandM : state.pegaMandM,
                SkipPegaRecommendation: action.value.rdSkipPegaRecommendation !== undefined &&
                    action.value.rdSkipPegaRecommendation !== state.SkipPegaRecommendation ? action.value.rdSkipPegaRecommendation : state.SkipPegaRecommendation,                      
                loadVHA: action.value.rdLoadVHA !== undefined &&
                    action.value.rdLoadVHA !== state.loadVHA ? action.value.rdLoadVHA : state.loadVHA,     

            })
        case 'CRMMSA_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                CRMMSARespStatus: action.value
            });
        case 'CRMMBUNDLE_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                CRMMBundleRespStatus: action.value
            });
        case 'CRMMPROMO_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                CRMMPromoRespStatus: action.value
            });
        case 'CRMMPROFILE_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                CRMMProfileRespStatus: action.value
            });
        case 'SSPGRID_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                sspGridRespSaveCallStatus: action.value
            });
        case 'PEGA_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                PegaRecommendationRespStatus: action.value
            });
        case 'CHANGE_RESPONSE':
            return Object.assign({}, state, {
                changeResponse: action.value
            })
        case 'CHANGE_DESCRIPTION_':
            return Object.assign({}, state, {
                changeDescription: action.value
            })
        case 'SET_CHANGE_APP_ACTIVE_VIEW':
            return Object.assign({}, state, {
                activeView: action.value
            })
        case 'SET_VZW_ACCOUNT_NUMBER':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    vzwAccountNumber: action.value
                })
            })
        case 'SET_VZW_ACCOUNT_DETAILS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    vzwAccountDetails: action.value
                })
            })
        case 'SET_VZW_ACCOUNT_RADIO_BTN':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    vzwAccountRadioBtn: action.value
                })
            })
        case 'SET_QUAL_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    qualSaveCallStatus: action.value
                })
            })
        case 'SHOW_MLP_OPTIONS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    showMlpOptions: action.value
                })
            })
        case 'SET_REDIRECT_QUERY_STRING':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    redirectQueryString: action.value
                })
            })
        case 'SET_ADDRESS_ID':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    addressId: action.value
                })
            })
        case 'SET_MTN':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    mtn: action.value
                })
            })
        case MnHOneClick.marketingProfileResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    marketingProfileResp: action.value
                })
            });
        case 'SET_MARKETING_PROFILE_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    marketingProfileRespSaveCallStatus: action.value
                })
            })
        case MnHOneClick.loopQualResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    loopQualResp: action.value
                })
            });
        case 'SET_LOOP_QUAL_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    loopQualRespSaveCallStatus: action.value
                })
            })
        case MnHOneClick.locusAddressValidationResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    locusAddressValidationResp: action.value
                })
            })
        case 'SET_LOCUS_ADDRESS_VALIDATION_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    locusAddressValidationRespSaveCallStatus: action.value
                })
            })
        case MnHOneClick.oneCreditResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    oneCreditResp: action.value
                })
            })
        case 'SET_ONE_CREDIT_RESP_SAVE_CALL_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    oneCreditRespSaveCallStatus: action.value
                })
            })
        case MnHOneClick.crmmStandaloneResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    crmmStandaloneResp: action.value
                })
            })
        case MnHOneClick.crmmBundleResponse:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    crmmBundleResponse: action.value
                })
            })
        case MnHOneClick.crmmPromoResponse:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    crmmPromoResponse: action.value
                })
            });
        case MnHOneClick.crmmEquipmentResponse:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    crmmEquipmentResponse: action.value
                })
            });
        case MnHOneClick.crmmVasResponse:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    crmmVasResponse: action.value
                })
            });
        case MnHOneClick.vzwOfferEligibilityResp:
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    vzwOfferEligibilityResp: action.value
                })
            })
        case 'SET_WIRELESS_DATA_TOKEN':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    wirelessDataToken: action.value
                })
            })
        case 'SET_WIRELESS_DATA_TOKEN_ENCRYPT_STATUS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    wirelessDataTokenEncryptStatus: action.value
                })
            })
        case 'SET_MHTOKEN_DETAILS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    mhToken: action.value
                })
            })
        case 'SET_VISIT_PROFILE_DETAILS':
            return Object.assign({}, state, {
                mnhOneClick: Object.assign({}, state.mnhOneClick, {
                    visitProfilejson: action.value
                })
            })
        case 'SET_PROMO_KEY_WORD':
            return Object.assign({}, state, {
                promoKeyWord: action.value
            });
        case 'SHOW_PROMO_KEY_WORD':
            return Object.assign({}, state, {
                showPromoKeyWord: action.value
            });
        default:
            return state
    }
}

export default changeApp